module.exports = __webpack_public_path__ + "img/loading-icon-driver.0d25b97f.png";